// Model
import { ApiResponse } from '../models/api-response.model';
import { Dropdown } from '@core/models/dropdown.model';
// Angular
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// RxJS
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BankHttpService {

  constructor(private http: HttpClient) { }

  getAllBanks(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/bankaccount/list?type=1`).pipe(
      map(res => res.data)
    );
  }

  getPaymenyMethods(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/paymentmethod?type=1&status=1`).pipe(
      map(res => res.data.rows)
    );
  }

  getPaymentGatewayBank(paymentGatewayCode: string): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/banks?payment_gateway_code=${paymentGatewayCode}`).pipe(
      map(res => res.data)
    );
  }

  getPaymentGateway(paymentMethodCode: any): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/paymentgateway?payment_method_code=${paymentMethodCode}`).pipe(
      map(res => res.data.rows)
    );
  }
}
